export default __webpack_public_path__ + "static/media/ProviderLate.0fde4603.svg";